import { motion } from 'framer-motion';

const BlogList = () => {
  const blogPosts = [
    {
      id: 1,
      title: '岡山市北区の訪問介護サービス利用の流れを詳しく解説',
      excerpt: '訪問介護サービスを初めて利用される方に向けて、申請から利用開始までの流れを分かりやすくご説明します。',
      date: '2024年1月15日',
      category: 'サービス案内',
      image: 'https://public.readdy.ai/ai/img_res/ea84f93253cb1006957fe120e7521314.jpg',
    },
    {
      id: 2,
      title: '介護保険制度の基礎知識｜岡山市北区での申請方法',
      excerpt: '介護保険制度の仕組みと、岡山市北区での申請手続きについて詳しく解説します。',
      date: '2024年1月10日',
      category: '制度解説',
      image: 'https://readdy.ai/api/search-image?query=japanese%20person%20reading%20healthcare%20insurance%20documents%20focused%20expression%20desk%20setting%20natural%20light%20simple%20background%20information&width=800&height=600&seq=blog-2&orientation=landscape',
    },
    {
      id: 3,
      title: '高齢者の健康維持に役立つ日常生活のポイント',
      excerpt: '自宅で実践できる健康維持のための運動や食事のアドバイスをご紹介します。',
      date: '2024年1月5日',
      category: '健康情報',
      image: 'https://readdy.ai/api/search-image?query=elderly%20japanese%20person%20doing%20gentle%20stretching%20exercises%20at%20home%20healthy%20active%20lifestyle%20natural%20indoor%20lighting%20simple%20background&width=800&height=600&seq=blog-3&orientation=landscape',
    },
    {
      id: 4,
      title: '訪問介護スタッフの1日｜岡山市北区での仕事内容',
      excerpt: '訪問介護スタッフの実際の業務内容や1日のスケジュールをご紹介します。',
      date: '2023年12月28日',
      category: '働き方',
      image: 'https://readdy.ai/api/search-image?query=japanese%20caregiver%20working%20with%20elderly%20person%20daily%20care%20activities%20warm%20home%20environment%20natural%20lighting%20simple%20background%20professional%20care&width=800&height=600&seq=blog-4&orientation=landscape',
    },
    {
      id: 5,
      title: '冬季の高齢者ケア｜寒さ対策と健康管理のポイント',
      excerpt: '冬場に気をつけたい高齢者の健康管理と、室内環境の整え方についてお伝えします。',
      date: '2023年12月20日',
      category: '季節の健康',
      image: 'https://readdy.ai/api/search-image?query=elderly%20japanese%20person%20staying%20warm%20at%20home%20in%20winter%20cozy%20comfortable%20setting%20natural%20indoor%20light%20simple%20background%20seasonal%20care&width=800&height=600&seq=blog-5&orientation=squarish',
    },
    {
      id: 6,
      title: '認知症の方への接し方｜家族ができるサポート',
      excerpt: '認知症の方と向き合う際の心構えや、日常生活でのサポート方法をご紹介します。',
      date: '2023年12月15日',
      category: '介護知識',
      image: 'https://readdy.ai/api/search-image?query=japanese%20family%20member%20gently%20caring%20for%20elderly%20person%20with%20dementia%20compassionate%20supportive%20atmosphere%20home%20setting%20simple%20background&width=800&height=600&seq=blog-6&orientation=landscape',
    },
    {
      id: 7,
      title: '岡山市北区の地域包括支援センター活用ガイド',
      excerpt: '地域包括支援センターの役割と、どのような相談ができるかを詳しく解説します。',
      date: '2023年12月10日',
      category: '地域情報',
      image: 'https://readdy.ai/api/search-image?query=japanese%20community%20support%20center%20consultation%20desk%20welcoming%20professional%20atmosphere%20natural%20lighting%20simple%20clean%20background&width=800&height=600&seq=blog-7&orientation=landscape',
    },
    {
      id: 8,
      title: '転倒予防のための自宅環境の整え方',
      excerpt: '高齢者の転倒リスクを減らすための、住環境の工夫と注意点をお伝えします。',
      date: '2023年12月5日',
      category: '安全対策',
      image: 'https://readdy.ai/api/search-image?query=safe%20japanese%20home%20interior%20for%20elderly%20handrails%20clear%20pathways%20well%20organized%20space%20natural%20lighting%20simple%20background%20safety%20features&width=800&height=600&seq=blog-8&orientation=landscape',
    },
    {
      id: 9,
      title: '介護サービスの種類と選び方｜岡山市北区版',
      excerpt: '訪問介護以外の介護サービスについても解説し、ご自身に合ったサービスの選び方をご案内します。',
      date: '2023年11月30日',
      category: 'サービス案内',
      image: 'https://readdy.ai/api/search-image?query=japanese%20family%20discussing%20elderly%20care%20options%20consultation%20meeting%20thoughtful%20expressions%20natural%20indoor%20lighting%20simple%20background&width=800&height=600&seq=blog-9&orientation=landscape',
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {blogPosts.map((post, index) => (
            <motion.article
              key={post.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.05 }}
              className="bg-beige-50 rounded-2xl overflow-hidden hover:shadow-lg transition-shadow cursor-pointer"
            >
              <div className="w-full h-48 sm:h-56 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-5 sm:p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs sm:text-sm text-coral-600 font-medium bg-coral-100 px-3 py-1 rounded-full whitespace-nowrap">
                    {post.category}
                  </span>
                  <span className="text-xs sm:text-sm text-navy-600 whitespace-nowrap">
                    {post.date}
                  </span>
                </div>
                <h3 className="text-base sm:text-lg font-bold text-navy-800 mb-3 leading-snug line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-xs sm:text-sm text-navy-700 leading-relaxed line-clamp-3 mb-4">
                  {post.excerpt}
                </p>
                <div className="flex items-center text-coral-600 font-medium text-xs sm:text-sm hover:text-coral-700 transition-colors">
                  <span>続きを読む</span>
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogList;
